<slider-arrow [side]="'left'"
              class="_arrow _left"
              [ngClass]="swiperPrefix + '-prev'"></slider-arrow>
<slider-arrow [side]="'right'"
              class="_arrow _right"
              [ngClass]="swiperPrefix + '-next'"></slider-arrow>